<template lang="pug">
.v-detail-news.detail-news(v-if="data")
	h1.detail-news__title(v-if="data.title" ) {{ data.title }}
	.detail-news__header
		h5.detail-news__date(v-if="data.date" ) {{ data.date }}
		.detail-news__actions(v-if="data.buttons" )
			button.detail-news__actions-btn.actions-btn(
					v-for="(button, index) in data.buttons"
					:key="index"
					:title="button.text"
					@click="onShare(button.notification)")
				v-svg-icon.detail-news__actions-icons(icon="share")
				//img.detail-news__actions-icons(
				//	v-if="button.image"
				//	:src="button.image?.src"
				//	:alt="button.image?.alt")
		//.detail-news__social(v-if="data.links" )
		//	a.detail-news__social-links(
		//			v-for="(item, index) in data.links"
		//			:href="item?.href"
		//			:target="item?.target"
		//			:key="index")
		//		img.detail-news__social-icons(
		//			v-if="item.image"
		//			:src="item.image?.src"
		//			:alt="item.image?.alt")
	.detail-news__separator
	img.detail-news__image(
		v-if="data.image"
		:src="data.image?.src"
		:alt="data.image?.alt")
	.detail-news__body(v-if="data.item" v-html="data.item")
	//v-image-slider.detail-news__slider(v-if="data.slider" :data-source="data.slider")
	.detail-news_slider(v-if="data.slider")
		.detail-news_slider-header
			h3.detail-news__slider-title(v-if="data.slider.title")
				| {{ data.slider.title }}
			.detail-news__slider-buttons
				button.detail-news__slider-button.slider-btn.left(ref="prev")
				button.detail-news__slider-button.slider-btn.right(ref="next")
		.detail-new__gallery-btn(v-if="!isXs" @click="openGallery")
			v-svg-icon.open-full__icon(icon="open-full")
		v-section-slider.detail-news_slider-body(:slider="data.slider" :navigation="navigation" @slideChange="slideChange" @openGallery="openGalleryFromImg")
	.detail-news__back.btn.btn--lg.btn-gap(@click="goBack")
		.btn-arrow.btn__icon
			.btn-arrow__track
				.btn-arrow__track-item
					v-scope
						v-svg-icon.icon-arrow(icon="btn-arrow")
				.btn-arrow__track-item
					v-scope
						v-svg-icon.icon-arrow(icon="btn-arrow")
		| {{ data?.variables?.back || 'back' }}
	.slider-gallery(v-if="gallery && !isXs")
		.slider-gallery__slider
			v-image-slider-gallery(:data-source="activeProduct" @close-gallery="closeGallery" :initial-index="activeIndex")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from "../scripts/controller/controller.js";
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue'
import scrollLock from "scroll-lock";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			navigation: false,
			gallery: false,
			activeIndex: null,
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
			this.$nextTick(() => {
				this.setNavigation()
			})
		},

		setNavigation() {
			this.navigation = {
				prevEl: this.$refs['prev'],
				nextEl: this.$refs['next']
			}
		},

		onShare(notification) {
			if (this.isXs) {
				navigator.share({
					title: this.data.title,
					url: window.location.href
				})
			} else {
				navigator.clipboard.writeText(window.location.href);
				controller.addNotification(notification);
			}
		},

		goBack() {
			history.back()
		},

		closeGallery() {
			this.gallery = false
			this.$emit('open-gallery', this.activeIndex)
		},
		openGallery() {
			this.gallery = true
			this.$emit('open-gallery', this.activeIndex)
		},

		slideChange(slider) {
			this.activeIndex = slider.realIndex;
		},

		openGalleryFromImg(slider) {
			this.activeIndex = slider.realIndex;
			this.openGallery();
		},
	},
	watch: {
		gallery() {
			if(this.gallery) {
				scrollLock.disablePageScroll(document.querySelector('.slider-gallery'));
			} else {
				scrollLock.enablePageScroll(document.querySelector('.slider-gallery'));
			}
		},
	},

	computed: {
		activeProduct() {
			let slider = this.data.slider
			slider.slides = this.data.slider.items
			return slider
		}
	}
}

</script>